export default __webpack_public_path__ + "static/media/map-poi-highlighted-icon.5393e2ae.svg";